import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'nx-ng-ticket-filter',
  templateUrl: './ticket-filter.component.html',
  styleUrls: ['./ticket-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketFilterComponent {
  @Input()
  label = '';

  @Output()
  edit: EventEmitter<void> = new EventEmitter<void>();

  handleClick() {
    this.edit.emit();
  }
}
